import { styled, Typography } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 34px;
  padding-top: 64px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1023px) {
    padding: 88px 16px;
  }
`;

export const Title = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  @media (max-width: 1023px) {
    margin-bottom: 16px;
  }
`;

export const CenteredRow = styled('div')`
  display: flex;
  width: 100%;

  @media (min-width: 1920px) {
    justify-content: center;
  }
`;

export const ContentW = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1080px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    max-width: calc(100% - 38px);
  }
`;
